document.addEventListener("DOMContentLoaded", () => {
    const carousel = document.querySelector(".c-carousel");
    if (!carousel) return;

    const scrollContainer = carousel.querySelector(".c-carousel__scroll");
    const items = Array.from(carousel.querySelectorAll(".c-carousel__item"));
    const btnPrev = carousel.querySelector(".c-carousel__prev");
    const btnNext = carousel.querySelector(".c-carousel__next");

    let currentIndex = 0;
    let isAnimating = false;
    const SNAP_RESTORE = "x mandatory";
    const SNAP_NONE = "none";
    const VIS_TOLERANCE = 1; // px tolerance for fractional pixels

    // ---- helpers -----------------------------------------------------------
    function containerRect() {
        return scrollContainer.getBoundingClientRect();
    }

    function itemRect(item) {
        return item.getBoundingClientRect();
    }

    // Comprueba si un elemento está completamente visible dentro del contenedor
    function isFullyVisible(el) {
        const c = containerRect();
        const r = itemRect(el);
        return r.left >= c.left - VIS_TOLERANCE && r.right <= c.right + VIS_TOLERANCE;
    }

    // Devuelve el índice del item cuya izquierda está más cerca del borde izquierdo del contenedor
    function indexClosestToStart() {
        const c = containerRect();
        let closest = 0;
        let minDist = Infinity;
        items.forEach((it, i) => {
            const r = itemRect(it);
            const dist = Math.abs(r.left - c.left);
            if (dist < minDist) {
                minDist = dist;
                closest = i;
            }
        });
        return closest;
    }

    function updateCurrentClass(index) {
        items.forEach((el, i) => el.classList.toggle("current", i === index));
    }

    // Habilita/deshabilita los botones prev/next según visibilidad del primer/último item
    function updateButtonsByViewport() {
        if (!btnPrev || !btnNext) return;
        btnPrev.disabled = isFullyVisible(items[0]);
        btnNext.disabled = isFullyVisible(items[items.length - 1]);
    }

    // Llamar para sincronizar UI (current + botones)
    function syncUI(index) {
        currentIndex = index;
        updateCurrentClass(currentIndex);
        updateButtonsByViewport();
    }

    // ---- easing / anim ----------------------------------------------------
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    // Animate scroll (Apple-style), con control del snap y callback al finalizar.
    function animateScrollTo(targetScrollLeft, duration = 500, onFinish = null) {
        if (isAnimating) return;
        isAnimating = true;

        const start = scrollContainer.scrollLeft;
        const distance = targetScrollLeft - start;
        const startTime = performance.now();

        // desactiva snap
        scrollContainer.style.scrollSnapType = SNAP_NONE;

        function step(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutQuad(progress);

            scrollContainer.scrollLeft = Math.round(start + distance * eased);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                // restaurar snap y marcar fin
                scrollContainer.style.scrollSnapType = SNAP_RESTORE;
                isAnimating = false;
                if (typeof onFinish === "function") onFinish();
            }
        }

        requestAnimationFrame(step);
    }

    // ---- navigation -------------------------------------------------------
    function goToIndex(index) {
        if (index < 0 || index >= items.length) return;
        const targetEl = items[index];

        // calculamos scrollLeft objetivo relativo al scrollContainer
        // usamos offsetLeft relativo al contenedor de scroll (content)
        const targetScrollLeft = targetEl.offsetLeft;

        animateScrollTo(targetScrollLeft, 500, () => {
            // Al terminar la animación sincronizamos UI con ese índice
            syncUI(index);
        });
    }

    // ---- scroll handlers --------------------------------------------------
    // Cuando termina el scroll manual (o con fallback) recalculamos el currentIndex
    function handleScrollEnd() {
        // si estamos animando, evitamos doble manejo
        if (isAnimating) return;

        const idx = indexClosestToStart();
        syncUI(idx);
    }

    // fallback: debounce para navegadores sin scrollend
    let scrollDebounce = null;
    function onScrollDebounced() {
        if (scrollDebounce) clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(() => {
            handleScrollEnd();
        }, 120);
    }

    // ---- inicialización ---------------------------------------------------
    function init() {
        // marcar primer elemento visible como current (mejor calcular real)
        const initialIndex = indexClosestToStart();
        syncUI(initialIndex);

        // listeners botones
        if (btnNext) {
            btnNext.addEventListener("click", () => {
                // si está disabled o ya animando, ignoramos
                if (btnNext.disabled || isAnimating) return;

                // busca el primer item no totalmente visible desde la derecha:
                // Normal behavior: intentar avanzar UNA posición relativa al item "closest"
                // Pero mantendremos la semántica: ir al siguiente índice
                const nextIndex = Math.min(items.length - 1, currentIndex + 1);
                goToIndex(nextIndex);
            });
        }

        if (btnPrev) {
            btnPrev.addEventListener("click", () => {
                if (btnPrev.disabled || isAnimating) return;
                const prevIndex = Math.max(0, currentIndex - 1);
                goToIndex(prevIndex);
            });
        }

        // scroll listeners: usaremos scrollend si existe, si no fallback al debounce
        if ("onscrollend" in scrollContainer) {
            scrollContainer.addEventListener("scrollend", handleScrollEnd);
        } else {
            // notar: algunos navegadores modernos implementan scrollend en el prototype,
            // si no está, usamos debounce sobre scroll
            scrollContainer.addEventListener("scroll", onScrollDebounced, { passive: true });
        }

        // también actualizamos botones al resize (items pueden entrar/salir)
        window.addEventListener("resize", () => {
            // recalcular y sincronizar tras resize
            const idx = indexClosestToStart();
            syncUI(idx);
        }, { passive: true });
    }

    // arranca
    init();
});
